import * as React from 'react';

import INotification, { TNotificationState, TType } from './INotification';

import { classNames } from '@features/utils/reactFunctions';

import * as style from './NotificationStyle.module.scss'
let ref: any = null;

export default class Notification extends React.PureComponent<INotification, TNotificationState> {
  state: TNotificationState = {
    error: '',
    type: '',
    class: '',
  };

  UNSAFE_componentWillMount() {
    ref = this;
  }

  onClick = () => {
    this.setState({ error: '', class: '' });
  }

  pushNotify = (type: TType, text: string, time: number) => {
    this.setState({
      type,
      error: text,
    }, () => {
      clearTimeout(this.state.timer);

      if (time) {
        const timer = window.setTimeout(() => {
          this.setState({
            class: 'fadeout',
          });

          setTimeout(() => {
            this.setState({
              error: '',
              class: '',
            });
          }, 800);
        }, time);

        this.setState({
          timer,
        });
      }
    });
  }

  hideNotify = (): void => {
    this.setState({
      error: '',
      class: '',
    });
  }

  renderActionNotify = (): JSX.Element|null => {
    const { className, children } = this.props;
    const { error } = this.state;

    if (!error) {
      return null;
    }

    return (
      <div
        className={
          classNames(
            style.notification,
            style[this.state.class],
            style['action'],
            className && style[className!]
          )
        }
      >
        <p>{error}</p>
        {children}
      </div>
    );
  }

  render() {
    const { type } = this.state;

    if (type === 'action') {
      return this.renderActionNotify();
    }

    const icon = type === 'error' ? 'fa-exclamation-triangle'
      : type === 'info' ? 'fa-info-circle' : '';

    return (
      this.state.error ? (
        <div
          onClick={this.onClick}
          className={[
            style.notification, style[this.state.class], style[type]].join(' ') +
            ` ${this.props.className ? style[this.props.className!] : ''}`
          }
          data-cy="notification"
        >
          <p><span className={`fa ${icon}`} /> <span dangerouslySetInnerHTML={{ __html: this.state.error }} /></p>
        </div>
      ) : null
    );
  }
}

export const hideNotify = (): void => ref ? ref.hideNotify() : null;

export const pushNotify = (type: TType = 'info', text: string, time: number = 0) => {
  ref ? ref.pushNotify(type, text, time) : null;
};

export const pushInfoNotify = (text: string, time: number = 5000): void => {
  pushNotify('info', text, time);
};

export const pushErrorNotify = (text: string, time: number = 5000): void => {
  pushNotify('error', text, time);
};

export const pushSuccessNotify = (text: string, time: number = 5000): void => {
  pushNotify('success', text, time);
};

export const pushActionNotify = (text: string, time: number = 0): void => {
  pushNotify('action', text, time);
};
